import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AccountLevel4Response } from 'src/app/models/account.model';
import { ButtonLoading } from 'src/app/models/button-loading.model';
import { JournalEntryRequest, JournalRequest } from 'src/app/models/journal.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { AccountService } from 'src/app/services/account.service';
import { JournalService } from 'src/app/services/journal.service';

@Component({
  selector: 'app-modal-create-accounting-entry',
  templateUrl: './modal-create-accounting-entry.component.html',
  styleUrls: ['./modal-create-accounting-entry.component.scss']
})
export class ModalCreateAccountingEntryComponent implements OnInit {
  buttonSave: ButtonLoading = new ButtonLoading("btn-success", false, "GUARDAR", "fa-save");
  buttonCheck: ButtonLoading = new ButtonLoading("btn-info", false, "COMPARAR CON AUXILIARES", "fa-search");
  @Output() close = new EventEmitter<any>();
  newJournal = new JournalRequest();
  accounts: AccountLevel4Response[] = [];
  inputAccount:
    {
      value: any,
      verified: boolean,
      required: boolean,
      message: string,
      class: string,
      color: string,
      tooltip: string,
      data: AccountLevel4Response,
      filter: AccountLevel4Response[]
    } = {
      value: null,
      verified: false,
      required: true,
      message: 'Campo requerido',
      class: "fa-list",
      color: '',
      tooltip: '',
      data: null,
      filter: []
    }
  tempEntry: JournalEntryRequest = new JournalEntryRequest();
  accountData: { [key: number]: AccountLevel4Response } = {};
  addedAccount: { [key: number]: boolean } = {};
  totalDebit = 0;
  totalCredit = 0;
  differences: { name: string, description: string }[] = [];
  differenceData: { [key: string]: string } = {};

  constructor(
    private accountService: AccountService,
    private toastService: ToastrService,
    private journalService: JournalService
  ) {

  }

  ngOnInit(): void {
    this.getStartData();
  }

  getStartData() {
    this.accountService.getAccountsLevel4().subscribe({
      next: (response: ResponseObject) => {
        this.inputAccount.filter = response.data;
        this.accounts = response.data;
        this.accounts.forEach((account) => {
          this.accountData[account.id] = account;
        })
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  writeAccount() {
    this.inputAccount.filter = this.accounts.filter((account) => {
      return account.displayId.includes(this.inputAccount.value) || account.name.toLowerCase().includes(this.inputAccount.value.toLowerCase())
    });
  }

  selectAccount(account: AccountLevel4Response) {
    this.tempEntry.account = account.id;
    this.inputAccount.value = account.displayId + " " + account.name;
    this.inputAccount.verified = true;
    this.inputAccount.required = true;
    this.inputAccount.class = "fa-circle-check";
  }

  addAccount() {
    if (this.addedAccount[this.tempEntry.account]) {
      this.toastService.info("La cuenta actualmente se encuentra agregada");
    } else {
      this.addedAccount[this.tempEntry.account] = true;
      var newAccount = new JournalEntryRequest();
      newAccount.account = this.tempEntry.account;
      newAccount.credit = this.tempEntry.credit;
      newAccount.debit = this.tempEntry.debit;
      this.totalCredit += this.tempEntry.credit;
      this.totalDebit += this.tempEntry.debit;
      this.tempEntry = new JournalEntryRequest();
      this.inputAccount.value = "";
      this.inputAccount.data = null;
      this.inputAccount.filter = this.accounts;
      this.inputAccount.class = "fa-list";
      this.newJournal.entries.push(newAccount);
    }
  }

  balancedAccounts() {
    return this.totalCredit.toFixed(2) === this.totalDebit.toFixed(2)
  }

  saveEntry() {
    if (this.buttonSave.loading) {
      return;
    }
    this.buttonSave.loading = true;
    var toSend = Object.assign({}, this.newJournal) as JournalRequest;
    if (toSend.date) {
      const localDate = new Date(toSend.date);
      localDate.setHours(localDate.getHours() + 6);
      toSend.date = localDate.getTime();
    }
    this.journalService.createJournal(toSend).subscribe({
      next: (response: ResponseObject) => {
        this.toastService.success("Se ha creado la partida");
        this.buttonSave.loading = false;
        this.close.emit(toSend);
      },
      error: (error: HttpErrorResponse) => {
        this.buttonSave.loading = false;
        this.toastService.error(error.error.message);
      }
    })
  }

  checkEntry() {
    if (this.buttonCheck.loading) {
      return;
    }
    this.buttonCheck.loading = true;
    var toCheck = Object.assign({}, this.newJournal) as JournalRequest;
    if (toCheck.date) {
      const localDate = new Date(toCheck.date);
      localDate.setHours(localDate.getHours() + 6);
      toCheck.date = localDate.getTime();
    }
    this.journalService.checkAuxiliaries(toCheck).subscribe({
      next: (response: ResponseObject) => {
        this.buttonCheck.loading = false;
        this.toastService.success("No se encontraron diferencias");
      },
      error: (error: HttpErrorResponse) => {
        this.buttonCheck.loading = false;
        this.differences = error.error.data;
        this.differences.forEach((difference) => {
          var displayId = difference.name.split('-')[0].trim();
          var description = difference.description;
          this.differenceData[displayId] = description;
        });
        this.differenceData['total'] = error.error.message;
        this.toastService.error(error.error.message);
      }
    })
  }

  editEntry(entry, index) {
    this.tempEntry = entry;
    this.totalCredit -= entry.credit;
    this.totalDebit -= entry.debit;
    this.newJournal.entries.splice(index, 1);
    this.inputAccount.value = this.accountData[entry.account].displayId + " " + this.accountData[entry.account].name;
    this.inputAccount.class = "fa-circle-check";
    delete this.addedAccount[entry.account];
  }

}
